/* eslint-disable import/no-duplicates */
import { format, isValid } from 'date-fns';
import { locales } from '@app/constants/date-locales.constant';
import i18n from '@app/i18n';

export const fullDate = (date: string | number | Date) =>
  format(new Date(date), 'yyyy-MM-dd HH:mm:ss');
export const shortDate = (date: string | number | Date) =>
  isValid(new Date(date)) ? format(new Date(date), 'dd-MM-yyyy') : '';
export const chatDate = (date: string | number | Date) => {
  return isValid(new Date(date)) ? format(new Date(date), 'HH:mm') : '';
};
export const transformSlashDate = (date: string | number | Date) =>
  isValid(new Date(date)) ? format(new Date(date), 'dd/MM/yyyy') : '';

export const transformSlashDateWithTime = (date: string | number | Date) =>
  format(new Date(date), 'dd/MM/yyyy HH:mm');

export const transformDateMonth = (date: string | number | Date) =>
  isValid(new Date(date))
    ? format(new Date(date), 'dd MMMM', { locale: locales[i18n.language] })
    : '';

export const dayAndMonthYearDate = (date: string | number | Date) =>
  format(new Date(date), 'dd MMMM yyyy');

export const dayAndTime = (date: string | number | Date) => format(new Date(date), 'dd MMMM HH:mm');
